import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, NewSelect, NewInput, NewModal, MainContentPaddingTypes } from "../..";
import { css, glyphs } from "../../../Styles";
import { ButtonTypes } from "../../../Definitions";

interface AAddEventModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
}

export default function AddEventModal({isModalOpen, closeModal}:AAddEventModal_Props) {
  const {t} = useTranslation()
  const [startDate, setStartDate] = useState<Date>(new Date());

  return (
    <NewModal
      modalState={isModalOpen}
      overrides={{ 
        mainContentPadding: MainContentPaddingTypes.secondary
      }}
      header={t("animalPages.animal.addEvent", {defaultValue: "add event"})}
      predefinedButtons={{
        onClose: closeModal
      }}
      mainContent={
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px"}}>
            <NewInput 
              startEnhancer={glyphs.Animal({size: "25px"})}
              placeholder={t("animalPages.animal.eventName", {defaultValue: "Name"})}
            />
            {/* <DateField value={startDate} onChange={({ date }) => setStartDate(date)} /> */}
            <NewSelect
              startEnhancer={glyphs.Animal({ size: "25px" })}
              placeholder={t("animalPages.animal.eventDate", {defaultValue: "Date"})} 
              options={[]}          />
            <NewInput 
              startEnhancer={glyphs.Animal({size: "25px"})}
              placeholder={t("animalPages.animal.eventNote", {defaultValue: "Note"})}
            />
          </div>
          <Button 
            content={t("buttons.create", {defaultValue: "create"})}
            buttonType={ButtonTypes.primaryButton}
            overrides={{
              baseButton: {...css.button_FitContent}
            }}
          />
        </div>
      }
    />
  );
}